
export const units = {
  getMushroomTypeText: (mushroomType) => {
    switch (mushroomType) {
      case 'unknown':
        return 'ไม่ทราบ'
      case 'poison':
        return 'เห็ดพิษ'
      case 'edible':
        return 'เห็ดกินได้'
    }
  }
}



// WEBPACK FOOTER //
// ./src/units/index.js